<template>
  <step :context="context" image="/images/alarm-clock.svg" @back="$emit('back')" @submit="submit">
    <template #guideTitle>One Step Away</template>
    <template #guideDescription>
      <div>
        <b>4. Promote Days and Times—</b>You can choose to reward your members with
        <b>double points or punches</b> on specific days and times.
        <div />
        <b>5. Marketing Automation to Win Back Customers—</b>incentivize lost members with a discount, and choose when to activate.
      </div>
    </template>
    <template #formTitle>Gifts and Special Promotions</template>
    <template #form>
      <v-form v-model="valid" ref="form">
        <!-- Promote Days -->
        <form-section
          class="promote-section"
          header="4. Promote Days and Times—Double Points/Punches"
          optional
        >
          <div class="inline">
            <div>On days</div>
            <!-- Days -->
            <v-checkbox
              v-for="day in ['Mon','Tue','Wed','Thu','Fri','Sat','Sun']"
              :key="day"
              :label="day"
              v-model="model.promoteDaysAndTimes.days[day.toLowerCase()]"
            />
          </div>
          <!-- Times -->
          <v-radio-group
            :row="!mobile"
            class="times ma-0"
            hide-details
            v-model="model.promoteDaysAndTimes.times.value"
            :rules="rules.promoteDaysAndTimes.times"
          >
            <v-radio label="All Day" value="allDay" />
            <custom-radio
              label="Specific hours"
              value="specificHours"
              v-slot="{selected}"
              :indent="mobile"
            >
              <v-text-field
                v-model="model.promoteDaysAndTimes.times.hours.from"
                type="time"
                placeholder="5:00 PM"
                :rules="rules.promoteDaysAndTimes.timeOption(selected)"
              />-
              <v-text-field
                v-model="model.promoteDaysAndTimes.times.hours.to"
                type="time"
                class="ml-2"
                placeholder="8:00 PM"
                :rules="rules.promoteDaysAndTimes.timeOption(selected)"
              />
            </custom-radio>
            <div
              class="hint"
            >Tip: We recommend occiasional email or text reminders about the promotion time period.</div>
          </v-radio-group>
        </form-section>
        <!-- Win Back -->
        <form-section
          header="5. Marketing Automation—Win Back Customers"
          optional
          tooltip="Como Sense Professional allow you to create unlimited campaigns"
        >
          <div class="inline ma-0 pa-0">
            <div>Activate</div>
            <v-text-field
              v-model="model.marketingAutomation.activate"
              class="minimal"
              prefix="₺"
              placeholder="5"
              :rules="[rules.number]"
            />
            <div>discount after</div>
            <v-select
              v-model="model.marketingAutomation.after"
              class="minimal-2"
              placeholder="After 60 days"
              :items="['Never','After 30 Days','After 60 Days','After 90 Days']"
            />
          </div>
        </form-section>
        <!-- Discount Alerts -->
        <form-section class="discount-section">
          <v-checkbox
            label="Send members text alerts when they are eligible for this discount."
            v-model="model.sendDiscountAlerts"
          />
          <div
            class="hint"
          >Monthly 500 SMS are included in your package. Additional usage charges will apply.</div>
          <div class="terms mt-4">
            <span>
              By submitting this form, I accept
              <a
                href="http://app4mobilebiz.wpengine.com/comosense-solution-general-terms.html"
                target="_blank"
              >Como - Bonobo's terms & conditions</a>.
              <div>An expert will get back to you to coordinate activation and training and to answer any questions you may have.</div>
            </span>
          </div>
        </form-section>
      </v-form>
    </template>
  </step>
</template>

<script>
import Step from "../Step";
import FormSection from "../FormSection";
import CustomRadio from "../CustomRadio";
import displayMixin from "@/mixins/display";

export default {
  props: ["context"],
  mixins: [displayMixin],
  components: {
    Step,
    FormSection,
    CustomRadio
  },
  data() {
    const required = v => !!v || "Field is required";
    const times = {
      value: null,
      hours: {
        from: null,
        to: null
      }
    };
    return {
      valid: false,
      rules: {
        required,
        number: v => v == null || !isNaN(Number(v)) || "Value must be a number",
        promoteDaysAndTimes: {
          times: [
            v => {
              const daySelected = Object.keys(
                this.model.promoteDaysAndTimes.days
              )
                .map(day => this.model.promoteDaysAndTimes.days[day])
                .find(day => day === true);
              return !daySelected || v != null || "";
            }
          ],
          timeOption(selected) {
            if (!selected) return [];

            return [
              required,
              () => {
                const { to, from } = times.hours;
                if (to && from && from > to) {
                  return "Range must be valid";
                }
                return true;
              }
            ];
          }
        }
      },
      model: {
        promoteDaysAndTimes: {
          days: {
            mon: false,
            tue: false,
            wed: false,
            thu: false,
            fri: false,
            sat: false,
            sun: false
          },
          times
        },
        marketingAutomation: {
          activate: null,
          after: null
        },
        sendDiscountAlerts: true,
        ...this.context.submittedData
      }
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate())
        this.$emit("done", { ...this.$data.model });
    }
  }
};
</script>

<style lang="scss" scoped>
.promote-section {
  .times {
    top: -14px !important;
    position: relative;
    .hint {
      margin-top: 4px !important;
    }
    ::v-deep input {
      max-width: 100px;
    }
    #app.mobile & {
      top: 12px !important;
    }
  }
}
.discount-section {
  .hint {
    #app.mobile & {
      margin-top: 12px;
    }
  }
  .terms {
    span {
      font-size: 9px;
      font-weight: 600;
      font-style: italic;
      line-height: 2;
      letter-spacing: 0.25px;

      a {
        color: #007aff;
      }
    }

    .grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 60px;
      max-width: 400px;

      #app.mobile & {
        grid-template-columns: 1fr;
      }
    }
  }
}
</style>